export default __webpack_public_path__ + "static/media/view2_year_province.8e155f29.csv";